import dayjs from 'dayjs';
import EvaluationTerm from './EvaluationTerm.js';
import BonusTermType from '../enums/BonusTermType.js';
import BonusTermStatus from '../enums/BonusTermStatus';
import Bonus from './Bonus.js';

export default class BonusTerm {
  constructor(data) {
    this.id = data?.id;
    this.organizationId = data?.organizationId;
    this.evaluationTermId = data?.evaluationTermId;
    this.status = data?.status ? BonusTermStatus.of(data.status) : null;
    this.type = data?.type ? BonusTermType.of(data.type) : null;
    this.name = data?.name;
    this.fund = data?.fund ? Number(data.fund) : null;
    this.allocationRatio = data?.allocationRatio ? Number(data.allocationRatio) : 0;
    this.createdAt = data?.createdAt ? dayjs(data.createdAt) : null;
    this.updatedAt = data?.updatedAt ? dayjs(data.updatedAt) : null;

    this.evaluationTerm = data?.evaluationTerm ? new EvaluationTerm(data?.evaluationTerm) : null;

    this.bonuses = data?.bonuses ? data?.bonuses.map(b => new Bonus(b)) : [];
  }
}
